
<template> 
    <div class="row g-6 g-xl-9" >  
        <div class="col-12 col-md-12 col-xl-12"> 
            <CardRh :processando="processando" titulo="LOGs" >  
                <KDataTable :reload="reloadDatatable" :config="config"  :pesquisar="false"  >   
                    <th class="text-center">Data</th> 
                    <th class="text-center">Model</th> 
                    <th class="text-center">ModelId</th> 
                    <th class="text-center">Tipo</th> 
                    <th class="text-center">Descrição</th> 
                    <th class="text-center">Ip</th> 
                    <th class="text-center">UsuarioId</th> 
                    <th class="text-center">host</th> 

                    <template v-slot:filtros>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                            <div class="mb-2">
                                <label for="DataMin" class="form-label">Data Mínima</label>
                                <input  @keyup="apertouEnter" @blur="refreshTable" v-model="data_min"  type="datetime-local" data-kt-docs-table-filter="DataMin" class="form-control form-control-solid " placeholder="Data Minima"/>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                            <div class="mb-2">
                                <label for="DataMax" class="form-label">Data Máxima</label>
                                <input  @keyup="apertouEnter" @blur="refreshTable"  v-model="data_max" type="datetime-local" data-kt-docs-table-filter="DataMax" class="form-control form-control-solid" placeholder="Data Maxima"/>
                            </div> 
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                            <div class="mb-2">
                                <label for="model" class="form-label">Model</label>
                                <input @keyup="apertouEnter" type="text" data-kt-docs-table-filter="model" class="form-control form-control-solid" placeholder="Model"/>
                            </div> 
                        </div> 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                            <div class="mb-2">
                                <label for="modelId" class="form-label">Model Id</label>
                                <input @keyup="apertouEnter" type="text" data-kt-docs-table-filter="modelId" class="form-control form-control-solid" placeholder="Model Id"/>
                            </div> 
                        </div>  
                                    
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3" v-if="tipos">
                            <div class="mb-2"> 
                                <label  for="tipoId" class="form-label">Tipo:</label>  
                                <Multiselect @change="refreshTable" :options="tipos_select" :searchable="true"  v-model="tipo_id" ></Multiselect>    
                            </div> 
                        </div> 
                        <input type="text" data-kt-docs-table-filter="tipoId" v-model="tipo_id" hidden/> 
                    </template> 
                </KDataTable>  
            </CardRh>  
        </div> 
    </div> 
</template>

<script lang="ts"> 
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import AuditoriaService from   "@/service/v1/seguranca/AuditoriaService"  
    import { Options , Vue } from "vue-class-component";   
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
    import { PerfilConfig } from "@/core/config/PerfisConfig";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth');   
    import Multiselect from '@vueform/multiselect'
      
    @Options({
        name: "Afastamento",
        components: {  CardRh , KDataTable , Multiselect   },   
    }) 
    export default class Afastamento extends Vue {
          
        @authStore.Getter
		public perfis!: any 
 
        public tipo_id: any = null;
        public tipos: any = null;
 
        public data_min: any = null;
        public data_max: any = null;
        public  meses =  ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];  
        public  dias =  ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];  
 
        public processando = false;  
        public reloadDatatable = false ;
        public config;  
        public service;  
 
        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }
        get hj() {
            return new Date().getFullYear() + '-' + this.meses[new Date().getMonth()] + '-' + this.dias[new Date().getDate() ] + ' 00:00';
        } 

        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis);
        }
         
        get tipos_select(){
            if(this.tipos){
                return this.tipos.map((item) => { return { value:  item.id , label: item.nome } });   
            }
            return null;
        }
 
        public getTipo(){   
            this.processando = true ; 
            this.service.getTipo(    ) 
            .then(response => {   
                this.tipos =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        created(){    
            this.data_min = this.hj; 
            this.config = { order: [[ 0, "desc" ]], ajax: {} , columns: {} , columnDefs: {} , };  
            this.service = new AuditoriaService();   
            this.getTipo(); 
            this.config.ajax = { 
                url: this.service.getApiUrl()  ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,
                        "DataMin": () => (document.querySelector('[data-kt-docs-table-filter="DataMin"]')! as HTMLInputElement).value ,
                        "DataMax": () => (document.querySelector('[data-kt-docs-table-filter="DataMax"]')! as HTMLInputElement).value ,  
                        "modelId": () => (document.querySelector('[data-kt-docs-table-filter="modelId"]')! as HTMLInputElement).value ,  
                        "model": () => (document.querySelector('[data-kt-docs-table-filter="model"]')! as HTMLInputElement).value ,  
                        "tipoId": () => (document.querySelector('[data-kt-docs-table-filter="tipoId"]')! as HTMLInputElement).value ,  
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 

            this.config.columns = [  
                { data: 'createdAt', name: 'createdAt', searchable: false ,   class: 'text-center' },
                { data: 'model', name: 'model', searchable: false ,   class: 'text-center' },
                { data: 'modelId', name: 'modelId', searchable: false ,   class: 'text-center' },
                { data: 'tipo', name: 'tipo', searchable: false ,   class: 'text-center' },
                { data: 'descricao', name: 'descricao', searchable: false ,   class: 'text-center' },
                { data: 'enderecoIP', name: 'enderecoIP', searchable: false ,   class: 'text-center' },
                { data: 'usuarioId', name: 'usuarioId', searchable: false ,   class: 'text-center' },
                { data: 'host', name: 'host', searchable: false ,   class: 'text-center' },
                
            ]; 

            this.config.columnDefs = [ 
                {
                    targets: 0,
                    render: function ( row, type, val, meta ) {   
                        return SiteUtils.formatDataHora( row )   ;  
                    }
                },   
                {
                    targets: 3,
                    render: function ( row, type, val, meta ) {   
                        return row != null ? row.nome : '';   
                    }
                },   
            ];   
        }    
    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    }
</style>